import styled, { css } from "styled-components";

interface IHomeSidebarContainer {
  loading?: number;
}

export const HomeSidebarContainer = styled.div<IHomeSidebarContainer>`
  width: 100%;
  height: 100%;
  background: transparent;
  display: flex;
  flex-direction: column;
  opacity: ${(props) => (props.loading === 1 ? "0" : "1")};
  transition: opacity 1s ease;

  ${(props) =>
    props.loading === 1 &&
    css`
      pointer-events: none;
    `}
`;

export const HomeSidebarLogo = styled.div`
  width: 100%;
  height: 6rem;
  background: #3fca89;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Righteous", sans-serif;
  font-size: 2.5rem;
  font-weight: 400;
  cursor: pointer;
`;

export const HomeSidebarMenus = styled.ul`
  width: 100%;
  height: auto;
  list-style: none;
  margin-top: 1rem;
`;

interface HomeSidebarMenuItemProps {
  active: number;
}

export const HomeSidebarMenuItem = styled.li<HomeSidebarMenuItemProps>`
  width: 100%;
  height: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  & i {
    font-size: 2.1rem;
    color: rgb(169, 169, 169);
  }

  &:hover i {
    color: #3fca89;
  }

  &:hover div {
    opacity: 1;
    visibility: visible;
    left: 150%;
  }

  ${(props) =>
    props.active === 1 &&
    css`
      & i {
        color: #3fca89;
      }
    `}
`;

export const HomeSidebarMenuItemTooltip = styled.div`
  position: absolute;
  top: 50%;
  left: 130%;
  background: #3fca89;
  transform: translateY(-50%);
  color: #fff;
  width: auto;
  height: 2rem;
  padding: 0 1rem;
  font-size: 1.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  box-shadow: 1px 2px 0px rgba(0, 0, 0, 0.12);
  opacity: 0;
  visibility: hidden;
  transition: left 0.2s ease;
  z-index: 1000;

  &::before {
    content: "";
    position: absolute;
    top: 50%;
    left: -0.3rem;
    width: 1rem;
    height: 1rem;
    background: inherit;
    transform: translateY(-50%) rotate(45deg);
    z-index: -1;
  }
`;

export const HomeSidebarSocialLinks = styled.ul`
  width: 100%;
  height: auto;
  list-style: none;
  margin-top: auto;

  & Li {
    width: 100%;
    height: 3.5rem;
    display: flex;
    justify-content: center;
    align-items: center;

    & i {
      color: rgb(169, 169, 169);
    }

    &:hover i {
      color: #3fca89;
    }
  }
`;
